import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createJobPosition(payload) {
    const globalStore = useGlobalStore();
    await api.post("/api/job-position/create", payload);
    globalStore.showSnackbar({
      show: true,
      text: "The job position has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });

    router.push("/company/job-position/overview");
  },

  async editJobPosition(payload) {
    const globalStore = useGlobalStore();
    await api.post(`/api/job-position/${payload.id}`, payload.data);
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
  },

  async getJobPositionOverview(payload) {
    const res = await api.get("/api/job-position/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getJobPosition(payload) {
    const res = await api.get(`/api/job-position/${payload.id}`);
    return res.data;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/job-position/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      name: null,
      foundWay: null,
      status: null,
      company: [],
      date: [],
      workingHours: null,
      parentLocation: null,
      location: null,
      contractType: null,
      workingShifts: null,
      workWeekSchedule: null,
      salaryRange: null,
      previousExperience: null,
      gender: null,
      age: null,
      drivingLicense: null,
      offersTraining: null,
      contactWhatsapp: null,
      openToPwD: null,
      offersTransportation: null,
      responsible: null,
      branch: null,
    };
  },
});

export default actions;
